import React from "react";

const CursorIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M5 3l14 9-6 1.5L10 21 5 3z"
      fill="white"
    />
  </svg>
);

const MicIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 14a3 3 0 003-3V6a3 3 0 10-6 0v5a3 3 0 003 3zm5-3a5 5 0 01-10 0H5a7 7 0 006 6.92V21h2v-3.08A7 7 0 0019 11h-2z"
      fill="white"
    />
  </svg>
);

const BoltIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z" fill="white" />
  </svg>
);

const steps = [
  {
    label: "STEP 01",
    icon: <CursorIcon />,
    title: "Click into any app",
    desc: "Outlook, Word, Chrome, a CRM field — wherever your cursor blinks, Zero Typing is ready.",
  },
  {
    label: "STEP 02",
    icon: <MicIcon />,
    title: "Speak naturally",
    desc: 'Talk like a person. Pauses, "ums", rambling — it all gets cleaned up into clear, structured text.',
  },
  {
    label: "STEP 03",
    icon: <BoltIcon />,
    title: "Done. No fixing.",
    desc: "Polished, ready-to-send text lands right where you were typing. No copy-paste, no edits.",
  },
];

const StepsSection = () => {
  return (
    <section className="w-full max-w-[1180px] mx-auto md:px-7 px-4 flex flex-col gap-10 md:gap-13">
      <div className="flex flex-col items-center gap-3 max-w-[720px] mx-auto">
        <h2 className="font-jakarta font-extrabold text-[#0F1B2D] text-center text-[2rem] sm:text-[2.4rem] md:text-[2.875rem] leading-[1.24] tracking-[-0.02em] capitalize">
          From Voice to Finished Text in{" "}
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#3AB1F6] to-[#407BFF]">
            One Breath
          </span>
        </h2>
        <p className="font-inter font-normal text-[#33425A] text-center text-[1rem] sm:text-[1.125rem] md:text-[1.3125rem] leading-[1.5] pt-1">
          No shortcuts to memorize, no formatting to clean up. Three steps and
          you're done.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-[22px]">
        {steps.map((s, i) => (
          <div
            key={i}
            className="rounded-[26px] bg-[#F9F9F9] border border-[#0000001A] p-[30px] pl-7 pr-7 flex flex-col gap-2"
          >
            <span
              className="font-jakarta font-extrabold text-[0.8125rem] tracking-[0.08em] uppercase"
              style={{ color: "#2E86E6" }}
            >
              {s.label}
            </span>
            <div
              className="w-14 h-14 rounded-2xl flex items-center justify-center"
              style={{
                background:
                  "linear-gradient(180deg, #3AB1F6 0%, #407BFF 100%)",
              }}
            >
              {s.icon}
            </div>
            <h3 className="font-jakarta font-bold text-[#0F1B2D] text-[1.3125rem] leading-[1.06] tracking-[-0.01em] pt-2">
              {s.title}
            </h3>
            <p className="font-inter font-normal text-[#33425A] text-[0.95rem] leading-[1.5]">
              {s.desc}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StepsSection;
